import React, { useState } from 'react';
import {
	MetadataSummaryLine,
	SummaryLabel,
	SummaryValue,
	ValueWrapper,
	MetadataSummary,
	EditActions,
	TableHeading,
	HeadingCell,
	ContentDiv,
	TableWrapper,
} from './EditWorkShopData.styles';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApInput,
} from '@alixpartners/ui-components';
import { useEffect } from 'react';

const EditWorkShopData = props => {
	const { onClose, updateWorkShopData } = props;
	const [editedOptions, setEditedOptions] = useState([]);
	const [data, setData] = useState(
		props.data.filter(dataObj => dataObj.workshop_id !== 99)
	);

	useEffect(
		() => {
			setData(props.data.filter(dataObj => dataObj.workshop_id !== 99));
		},
		[props.data]
	);

	const handleLabelChange = (event, workshopId) => {
		const updatedOptions = data.map(
			obj =>
				obj.workshop_id === workshopId
					? {
							...obj,
							workshop_name: event,
					  }
					: obj
		);

		setData(updatedOptions);

		const editedOption = updatedOptions.find(
			option => option.workshop_id === workshopId
		);

		if (editedOption) {
			const editedIndex = editedOptions.findIndex(
				eOpt => eOpt.value === editedOption.value
			);

			if (editedIndex !== -1) {
				setEditedOptions(prevEditedOptions => {
					prevEditedOptions[editedIndex].workshop_name =
						editedOption.workshop_name;
					return [...prevEditedOptions];
				});
			} else {
				setEditedOptions(prevEditedOptions => [
					...prevEditedOptions,
					editedOption,
				]);
			}
		}
	};

	function addInputField() {
		const getHighestIndex = data => {
			let highest = 0;
			data.forEach(obj => {
				if (obj.workshop_id > highest) {
					highest = obj.workshop_id;
				}
			});
			return highest;
		};

		setData([
			...data,
			{ workshop_id: getHighestIndex(data) + 1, workshop_name: '' },
		]);
	}

	const saveSettings = () => {
		updateWorkShopData(...editedOptions, data);
		onClose(false);
	};

	return (
		<ContentDiv>
			<TableWrapper>
				<TableHeading>
					<HeadingCell>Workshop ID</HeadingCell>
					<HeadingCell>Workshop Name</HeadingCell>
				</TableHeading>
				<MetadataSummary>
					{data.map((workshop, index) => {
						if (workshop.workshop_id !== 99) {
							return (
								<MetadataSummaryLine key={index}>
									<SummaryLabel>{workshop.workshop_id}.</SummaryLabel>
									<SummaryValue>
										<ValueWrapper>
											<ApInput
												value={workshop.workshop_name}
												type="text"
												name={workshop.workshop_name}
												onChange={event =>
													handleLabelChange(event, workshop.workshop_id)
												}
											/>
										</ValueWrapper>
									</SummaryValue>
								</MetadataSummaryLine>
							);
						}
						return null;
					})}
				</MetadataSummary>
			</TableWrapper>
			<EditActions>
				<ApButtonSecondary onClick={addInputField}>Add Row</ApButtonSecondary>

				<div style={{ margin: '0 5px 0 0' }}>
					<ApButtonMain
						onClick={saveSettings}
						disabled={editedOptions.length === 0}
					>
						Save
					</ApButtonMain>
				</div>
				<div>
					<ApButtonSecondary
						onClick={() => {
							// setShowSideBar(false);
							onClose(false);
						}}
					>
						Close
					</ApButtonSecondary>
				</div>
			</EditActions>
		</ContentDiv>
	);
};

export default EditWorkShopData;
